import { ArticleCategory, ArticleType, ArticleTypeExternal } from '@nemuru-eng/js-api-client';

import { ICON_NAMES } from '@/config/config';

export class ArticleTypeMap {
  public static toArticleType(articleType: ArticleTypeExternal): ArticleType {
    // @ts-expect-error Property 'ONLINE_PRODUCT' does not exist on type 'ArticleTypeExternal'
    if (articleType === ArticleType.ONLINE_PRODUCT) return ArticleType.ONLINE_PRODUCT;
    if (articleType === ArticleTypeExternal.PRODUCT) return ArticleType.ONLINE_PRODUCT;
    if (articleType === ArticleTypeExternal.SERVICE) return ArticleType.SERVICE;
    if (articleType === ArticleTypeExternal.ACCOMMODATION) return ArticleType.ACCOMMODATION;
    if (articleType === ArticleTypeExternal.FLIGHT) return ArticleType.FLIGHT;
    if (articleType === ArticleTypeExternal.TRAVEL) return ArticleType.TRAVEL;
    if (articleType === ArticleTypeExternal.AUTOMOBILE) return ArticleType.AUTOMOBILE;
    if (articleType === ArticleTypeExternal.CREDIT_CARD) return ArticleType.CREDIT_CARD;
    console.error(`Unknown article type: ${articleType}`);
    return ArticleType.ONLINE_PRODUCT;
  }
  public static toArticleTypeExternal(articleType: ArticleType): ArticleTypeExternal {
    if (articleType === ArticleType.ONLINE_PRODUCT) return ArticleTypeExternal.PRODUCT;
    if (articleType === ArticleType.SERVICE) return ArticleTypeExternal.SERVICE;
    if (articleType === ArticleType.ACCOMMODATION) return ArticleTypeExternal.ACCOMMODATION;
    if (articleType === ArticleType.FLIGHT) return ArticleTypeExternal.FLIGHT;
    if (articleType === ArticleType.TRAVEL) return ArticleTypeExternal.TRAVEL;
    if (articleType === ArticleType.AUTOMOBILE) return ArticleTypeExternal.AUTOMOBILE;
    if (articleType === ArticleType.CREDIT_CARD) return ArticleTypeExternal.CREDIT_CARD;
    console.error(`Unknown article type: ${articleType}`);
    return ArticleTypeExternal.PRODUCT;
  }

  public static toIcon(articleType: ArticleType): string {
    if (articleType === ArticleType.ONLINE_PRODUCT) return ICON_NAMES.PRODUCT;
    if (articleType === ArticleType.SERVICE) return ICON_NAMES.SERVICE;
    if (articleType === ArticleType.ACCOMMODATION) return ICON_NAMES.ACCOMMODATION;
    if (articleType === ArticleType.FLIGHT) return ICON_NAMES.FLIGHT;
    if (articleType === ArticleType.TRAVEL) return ICON_NAMES.TRAVEL;
    if (articleType === ArticleType.AUTOMOBILE) return ICON_NAMES.AUTOMOBILE;
    if (articleType === ArticleType.CREDIT_CARD) return ICON_NAMES.CREDIT_CARD;
    console.error(`Unknown article type: ${articleType}`);
    return ICON_NAMES.PRODUCT;
  }

  public static toArticleCategories(articleType: ArticleType): ArticleCategory[] {
    switch (articleType) {
      case ArticleType.ONLINE_PRODUCT:
        return [ArticleCategory.PHYSICAL, ArticleCategory.DIGITAL, ArticleCategory.SHIPPING_FEE];
      case ArticleType.ACCOMMODATION:
      case ArticleType.FLIGHT:
      case ArticleType.AUTOMOBILE:
        return [ArticleCategory.PHYSICAL];
      default:
        return [ArticleCategory.PHYSICAL, ArticleCategory.DIGITAL];
    }
  }
}
